import { MissingTranslationHandler, MissingTranslationHandlerParams } from "@ngx-translate/core";

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return `**MISSING KEY: ${params.key}**`;
  }
}
